import { config } from '../config'
import { requests } from '../utils'
const LOCATION_SERVICE_URL = config?.LOCATION_SERVICE_URL

interface GetLocation {
  skip: number
  limit: number
  query?: string
  companyId: string
  deleted: boolean
}

export enum TemplateType {
  SMS = 'sms',
  EMAIL = 'email',
}

export const DEFAULT_TEMPLATE_FETCH_LIMIT = 1000

export const LocationServices = {
  getLocations: (params: GetLocation) =>
    requests(LOCATION_SERVICE_URL).get('/locations/search', { params }),
  getTemplatesForLocationAndType: (
    locationId: string,
    templateType: TemplateType
  ) =>
    requests(LOCATION_SERVICE_URL).get(
      `locations/${locationId}/templates?type=${templateType}&limit=${DEFAULT_TEMPLATE_FETCH_LIMIT}`,
      {
        headers: {
          'internal-channel': 'proposals',
          'location-id': locationId,
        },
      }
    ),
}
